<div class="activity-list" aria-live="polite" [attr.aria-busy]="store.isLoading">
  @if (rows.length) {
    <ul class="activity-list__rows">
      @for (card of rows; track $index) {
        <li><ut-community-profile-activity-card [card]="card"></ut-community-profile-activity-card></li>
      }
    </ul>
  } @else if (!store.isLoading) {
    <div class="card empty">
      <span class="empty__icon" aria-hidden="true"><span class="material-icons">forum</span></span>
      <p class="empty__title">{{ emptyTitle }}</p>
    </div>
  }

  @if (store.isLoading) {
    <ut-skeleton-list></ut-skeleton-list>
  } @else if (!store.isLastPage) {
    <button type="button" class="ut-btn ut-btn--secondary more" (click)="loadMore()">View more</button>
  }
</div>
